import { Outlet } from 'react-router'
import { NavLink } from 'react-router-dom'

import { ROUTER_NAMES } from 'router/routerNames'

import styles from './LogisitcPageLayout.module.scss'

function activeClassName({ isActive }: { isActive: boolean }) {
  return `${styles.nav_item} ${isActive ? styles.active : ''}`
}

export function LogisitcPageLayout() {
  return (
    <>
      <div className="container">
        <div className={styles.nav_list}>
          <NavLink end className={activeClassName} to={ROUTER_NAMES.LOGISTIC}>
            Новые заявки
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.LOGISTIC_PROCESSED}
          >
            Обработанные заявки
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.LOGISTIC_FILLIALS_APPS}
          >
            Заявки Филлиалов/СК
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.LOGISTIC_FILLIALS_ACTS}
          >
            Акты Филлиалов/СК
          </NavLink>
          <NavLink
            className={activeClassName}
            to={ROUTER_NAMES.LOGISTIC_REPORTS}
          >
            Отчеты
          </NavLink>
        </div>
      </div>

      <Outlet />
    </>
  )
}
